import { Colors, fontMedium } from "swing-components";

type TextFieldProps = {
  type?: "text" | "tel" | "email" | "password" | "number";
  label?: string;
  value?: string;
  placeholder?: string;
  isDisabled?: boolean;
  onChange: (value: string) => void;
  pattern?: string;
  maxLength?: number;
  inputMode?: "text" | "numeric";
};

/**
 * Component | TextField
 *
 * Renders a label and a text input.
 */
export function TextField(props: TextFieldProps) {
  const {
    type = "text",
    value = "",
    label,
    placeholder,
    onChange,
    isDisabled,
    pattern,
    maxLength,
    inputMode,
  } = props;
  /***** Render *****/
  return (
    <label
      css={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        ...fontMedium({
          color: !isDisabled ? "black" : "slate300",
        }),
      }}
    >
      {/* Optional label */}
      {label && <div css={{ fontWeight: 600 }}>{label}</div>}

      {/* Input */}
      <input
        onChange={(e) => onChange(e.target.value)}
        value={value}
        type={type}
        disabled={isDisabled}
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
        placeholder={placeholder}
        spellCheck={false}
        aria-label={label}
        pattern={pattern}
        maxLength={maxLength}
        inputMode={inputMode}
        css={{
          paddingBottom: 8,
          border: "none",
          borderBottom: `1px solid ${Colors.slate400}`,
          width: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          background: "transparent",
          outline: "none",
          appearance: "none",
          touchAction: "manipulation",
          "&::placeholder": {
            color: Colors.slate300,
          },
        }}
      />
    </label>
  );
}
